import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalDataService } from '../../../../shared-services/global-data.service';

@Component({
  selector: 'app-terms-policy',
  templateUrl: './terms-policy.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./terms-policy.component.scss']
})
export class TermsPolicyComponent implements OnInit {

  constructor(private modalService: NgbModal, private globalDataService: GlobalDataService) { }

  ngOnInit(): void {
  }

  openTerms(content) {
    this.modalService.open(content, { size: 'xl' , windowClass: 'shortenHeight'});
  }

  getCurrentLang(){
    return this.globalDataService.getCurrentLang();
  }

}
